module.exports = __webpack_public_path__ + "top_page/img-novelty-item-53108bb64cf3e7cb5719bcffb8d4b8a6.webp";